<template>
    <div>
        <a-alert v-if="errorMessage" type="error" :message="errorMessage" banner closable
            @close="errorMessage = null" />

        <!-- filter -->
        <ARow :gutter="[8, 8]">
            <ACol :xl="6" :md="8" :sm="12">
                <ASelect :options="state.statusLists" allow-clear style="width:100%;" placeholder="Pilih Status"
                    v-model:value="state.params.status" />
            </ACol>
            <ACol :xl="6" :md="8" :sm="12">
                <AInputSearch v-model:value="state.params.q" placeholder="Cari..." style="width:100%" />
            </ACol>
            <ACol :xl="6" :md="8" :sm="12">
                <AButton type="primary" title="cari" @click="fetchDataList" :loading="state.isFetching">
                    <span v-if="!state.isFetching" class="fa fa-search" aria-hidden="true" />
                    <span v-else>
                        Memuat Data ...
                    </span>
                </AButton>
            </ACol>
        </ARow>

        <!-- button action menu -->
        <div class="row justify-content-end mt-4">
            <div class="col-lg-6 col-md-12"></div>
            <div class="col-lg-6 col-md-12 text-right">
                <ASpace>
                    <ATooltip title="Tambahkan">
                        <AButton type="primary" @click="btnForm">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </AButton>
                    </ATooltip>
                    <ATooltip title="Download excel">
                        <DownloadExcel :url="state.endpoint" :params="state.params"
                            namefile="Master-Data-Segment-Project-Derivatives" @errors="errorMessage" />
                    </ATooltip>
                </ASpace>
            </div>
        </div>

        <!-- list tabel -->
        <div class="table-responsive mt-4">
            <MdTable :columns="state.columns" :data-source="state.data" size="small" row-key="id"
                :loading="state.isFetching" :meta="state.meta" @change="handleTableChange">
                <template #customTitle>
                    <span> Status </span>
                </template>
                <template #value="{ text }">
                    <span class="font-weight-bold">{{ text }}</span>
                </template>
                <template #id="{ text }">
                    <a href="javascript: void(0);" class="btn btn-sm btn-light">{{ text }}</a>
                </template>
                <template #status="{ text }">
                    <a-tag v-if="text === null" color="green">
                        Aktif
                    </a-tag>

                    <a-tag v-else color="red">
                        Tidak Aktif
                    </a-tag>
                </template>
                <template #action="{ record }">
                    <ASpace>
                        <ATooltip title="Edit">
                            <AButton class="button" size="small" @click="btnForm(record)">
                                <i class="fe fe-edit" />
                            </AButton>
                        </ATooltip>
                        <ATooltip title="Lihat">
                            <AButton class="button" size="small" @click="btnForm(record, true)">
                                <i class="fe fe-eye" />
                            </AButton>
                        </ATooltip>
                        <ATooltip :title="record.deleted_at ? 'Aktifkan' : 'Nonaktifkan'">
                            <AButton class="button" size="small" @click="updateStatus(record)">
                                <i :class="record.deleted_at ? 'fe fe-refresh-cw' : 'fe fe-slash'" />
                            </AButton>
                        </ATooltip>
                        <!-- <ATooltip title="Hapus">
                            <AButton danger size="small" @click="hapus(record)">
                                <i class="fe fe-trash-2" />
                            </AButton>
                        </ATooltip> -->
                    </ASpace>
                </template>
            </MdTable>
        </div>

        <!-- form -->
        <Form v-if="visibleFormModal" v-model:visible="visibleFormModal" v-model:item="visibleFormItemModal"
            @success="fetchDataList" />
    </div>
</template>
<script>
import Form from "./Form";
import { defineComponent, ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import apiClient from '@/services/axios'
import { Modal, message } from 'ant-design-vue'
import DownloadExcel from "@/components/Molecules/DownloadExcel";
import { updateUrlWithQuery, extractQueryParams } from '@/helpers/queryparams'

export default defineComponent({
    components: {
        // FilterProvinsi,
        // FilterKabupatenKota,
        // FilterDistributorDerivatives,
        DownloadExcel,
        Form,
    },
    setup() {
        const errorMessage = ref();
        const router = useRouter();
        const state = reactive({
            columns: [
                {
                    title: "No",
                    slots: { customRender: "no" },
                },
                {
                    title: "Kode",
                    dataIndex: "code",
                },
                {
                    title: "Nama",
                    dataIndex: "name",
                },
                {
                    title: "Status",
                    dataIndex: "deleted_at",
                    slots: { customRender: "status" },
                },
                {
                    title: "Action",
                    slots: { customRender: "action" },
                },
            ],
            endpoint: "/api/derivatives/segment-projects",
            params: extractQueryParams({
                q: '',
                status: null,
                type: 1,
                page: 1,
                'per-page': 10,
            }),
            data: [],
            statusLists: [
                { value: 1, label: 'Aktif' },
                { value: 0, label: 'Tidak Aktif' },
            ],
            meta: null,
            isFetching: false,
        });

        // handle form
        const visibleFormModal = ref(false);
        const visibleFormItemModal = ref(null);

        const btnForm = (item = null, readOnly = false) => {
            visibleFormModal.value = true;
            visibleFormItemModal.value = {
                ...item,
                readOnly,
            };
        };

        // fetch list data
        const fetchDataList = () => {
            state.isFetching = true

            apiClient
                .get(state.endpoint, {
                    params: {
                        ...updateUrlWithQuery(state.params),
                        type: 1,
                        status: state.params.status,
                    },
                })
                .then(({ data }) => {
                    const { items, _meta } = data

                    state.data = items
                    state.meta = _meta
                })
                .finally(() => {
                    state.isFetching = false
                })
        }

        const hapus = (record) => {
            Modal.confirm({
                title: 'Konfirmasi',
                content: `Hapus Segment Project "${record.name}"?`,
                okText: 'Ya',
                cancelText: 'Batal',

                async onOk() {
                    try {
                        await apiClient.delete(`${state.endpoint}/${record.id}`)

                        message.success('Data berhasil dihapus')

                        fetchDataList()
                    } catch (error) {
                        message.error(
                            error.response?.data?.message || 'Gagal menghapus data',
                        )
                    }
                },
            })
        }

        const updateStatus = (record) => {
            Modal.confirm({
                title: 'Konfirmasi',
                content: record.deleted_at
                    ? 'Aktifkan kembali data ini?'
                    : 'Nonaktifkan data ini?',

                async onOk() {
                    await apiClient.put(`${state.endpoint}/${record.id}/status`)

                    message.success('Status berhasil diubah')

                    fetchDataList()
                },
            })
        }

        // handle vue
        onMounted(() => {
            fetchDataList()
        })

        const handleTableChange = (pagination) => {
            state.params.page = pagination.current
            state.params['per-page'] = pagination.pageSize

            fetchDataList()
        }

        return {
            visibleFormModal,
            visibleFormItemModal,
            errorMessage,
            fetchDataList,
            btnForm,
            updateStatus,
            handleTableChange,
            state,
            hapus,
        };
    },
});
</script>
<style scoped></style>
